// extracted by mini-css-extract-plugin
export default {"detailContainer":"styles_detailContainer__LDZcV","icon":"styles_icon__IM-sn"};